import axios from "axios";
import Vue from "vue";
import router from "../router";
import { message } from "ant-design-vue";
import { baseURL } from "../config/config";

const service = axios.create({
  baseURL: baseURL,
  timeout: 60000,
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
});
// service.interceptors.request.use(
//   config => {
//     const token = getToken();
//     // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
//     if (token) {
//       config.headers["Authorization"] = token;
//     }
//     return config;
//   },
//   error => Promise.reject(error)
// );
service.interceptors.response.use(
  response => {
    let data = response.data;
    if (!data.success) {
      message.error(data.subMsg);
      localStorage.removeItem("user_info");
      router.push({ name: "login" });
      return Promise.reject(data.subMsg);
    } else {
      return response.data;
    }
  },
  error => {
    localStorage.removeItem("user_info");
    router.push({ name: "login" });
    if (error.code) {
      message.error("网络超时....");
    }
    if (error.response && error.response.data) {
      message.error(JSON.stringify(error.response.data));
      // if (error.response.status === 401) {
      //   router.push("/login");
      // }
    }
    return Promise.reject(error);
  }
);

Vue.prototype.$axios = params => {
  params.method = params.method || "post";
  return service(params);
};
